import { FunctionComponent } from 'preact';
import { route, RoutableProps } from 'preact-router';
import { Layout } from '../components/layout';

export const NotFoundPage: FunctionComponent<RoutableProps> = () => {
  return (
    <Layout title="Nicht gefunden" subtitle="Diese Seite gibt es nicht.">
      <button class="btn mt-md" onClick={() => route('/', true)}>
        Zur Startseite
      </button>
    </Layout>
  );
};
